// LPPLWEBMOB-728
import { getConfig } from "./getConfig";

export const getAddressInformationBasedOnPostalCode = async (
  postalCode: string
): Promise<AddressData | undefined> => {
  const config = await getConfig();
  try {
    const response = await fetch(
      `${config.apiPostalCodesAndModelsEndpoint}addresses?id=${postalCode}`
    ).then((r) => r.json());

    if (!response.length) {
      return;
    }

    //const streets = response.map((item: { Street: string }) => item.Street);
    const cities = response.map((item: { City: string }) => item.City);

    //const streetsSet = ([...new Set(streets)] as unknown) as string[];
    const citiesSet = ([...new Set(cities)] as unknown) as string[];

    // const streetsOptions =
    //   streetsSet.length === 1 && (streetsSet[0] === "" || streetsSet[0] == null)
    //     ? []
    //     : streetsSet.map((item) => ({ value: item, label: item }));

    const citiesOptions =
      citiesSet.length === 1 && (citiesSet[0] === "" || citiesSet[0] === null)
        ? []
        : citiesSet.map((item) => ({ value: item, label: item }));

    return {
      cities: citiesOptions,
      // voivodeship: response[0].Voivodeship,
      // streets: streetsOptions,
    };
  } catch {
    return undefined;
  }
};
export interface AddressData {
  //city?: string;
  cities: { label: string; value: string }[];
  //voivodeship: string;
  //streets: { label: string; value: string }[];
}
